import styled, { createGlobalStyle } from 'styled-components';
import PessoaEstudando from '../../assets/img/pessoa_estudando.jpg';
import DanizinhaRindo from '../../assets/img/Danizinha_rindo.png';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Fraunces:wght@600;700&family=Space+Grotesk:wght@500;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Inter', sans-serif;
    line-height: 1.6;
    color: #333;
  }

  html {
    scroll-behavior: smooth;
  }

  :root {
    --color-primary-a: #009bd9;
    --color-primary-b: #024995;
    --color-primary-c: #f39200;
    --color-support: #a4acb1;
    --color-primary-a-rgb: 0, 155, 217;
    --color-primary-b-rgb: 2, 73, 149;
    --color-primary-c-rgb: 243, 146, 0;
    --color-support-rgb: 164, 172, 177;
  }


`;

export const Container = styled.div`
  min-height: 100vh;
  background: #ffffff;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

export const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, #024995 0%, #009bd9 60%, #009bd9 100%);
  z-index: 1000;
  height: 80px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const Nav = styled.nav`
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  padding: 0 2rem;
  gap: 1rem;
  height: 100%;
  
  @media (max-width: 1368px) {
    grid-template-columns: 1fr auto auto;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  justify-self: start;
  background: white;
  border-radius: 10px;
  padding: 5px 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  
  img {
    height: 36px;
    width: auto;
    object-fit: contain;
    display: block;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.85;
    }

    @media (max-width: 768px) {
      height: 30px;
    }

    @media (max-width: 480px) {
      height: 26px;
    }
  }
  
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  justify-self: center;
  
  a {
    text-decoration: none;
    color: white;
    font-weight: 500;
    transition: color 0.3s ease;
    white-space: nowrap;
    font-size: 0.95rem;
    
    &:hover {
      color: var(--color-primary-c);
    }
  }

  @media (max-width: 1500px) {
    gap: 1rem;

    a {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 1440px) {
    gap: 0.75rem;

    a {
      font-size: 0.85rem;
    }
  }
  
  @media (max-width: 1368px) {
    display: none;
  }
`;

export const LoginButton = styled.button`
  background: white;
  color: var(--color-primary-b);
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  justify-self: end;
  white-space: nowrap;
  
  &:hover {
    background: #f8f9fa;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(var(--color-primary-a-rgb), 0.2);
  }

  @media (max-width: 1500px) {
    padding: 0.65rem 1.2rem;
    font-size: 0.95rem;
  }
  
  @media (max-width: 1368px) {
    display: none;
  }
`;

export const MobileMenuContainer = styled.div`
  display: none;
  position: relative;
  justify-self: end;
  
  @media (max-width: 1368px) {
    display: block;
  }
`;

export const HamburgerButton = styled.button<{ isOpen?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  
  span {
    width: 30px;
    height: 3px;
    background: white;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
    
    &:first-child {
      transform: ${({ isOpen }) => isOpen ? 'rotate(45deg)' : 'rotate(0)'};
    }
    
    &:nth-child(2) {
      opacity: ${({ isOpen }) => isOpen ? '0' : '1'};
      transform: ${({ isOpen }) => isOpen ? 'translateX(-20px)' : 'translateX(0)'};
    }
    
    &:nth-child(3) {
      transform: ${({ isOpen }) => isOpen ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`;

interface HamburgerButtonProps {
  isOpen?: boolean;
}


interface MobileMenuProps {
  isOpen: boolean;
}

export const MobileMenu = styled.div<MobileMenuProps>`
  position: absolute;
  top: 52px;
  right: 0;
  width: 270px;
  max-height: calc(100vh - 120px);
  background: linear-gradient(160deg, #024995 0%, #009bd9 100%);
  border-radius: 16px;
  padding: 1.25rem 1.5rem 1.5rem;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(255,255,255,0.08);
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  transform: ${({ isOpen }) => isOpen ? 'translateY(0) scale(1)' : 'translateY(-12px) scale(0.97)'};
  opacity: ${({ isOpen }) => isOpen ? '1' : '0'};
  visibility: ${({ isOpen }) => isOpen ? 'visible' : 'hidden'};
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease, visibility 0.25s ease;
  z-index: 1000;
  
  a {
    text-decoration: none;
    color: rgba(255, 255, 255, 0.88);
    font-weight: 500;
    font-size: 0.95rem;
    padding: 0.65rem 0.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    transition: color 0.2s ease, padding-left 0.2s ease;
    display: flex;
    align-items: center;
    
    &:hover {
      color: white;
      padding-left: 0.75rem;
    }
  }
  
  a:last-of-type {
    border-bottom: none;
  }
`;

export const MobileMenuDivider = styled.hr`
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  margin: 0.25rem 0 0.5rem;
`;


export const MobileLoginButton = styled.button`
  background: white;
  color: var(--color-primary-b);
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  width: 100%;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  
  &:hover {
    background: #f0f4ff;
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const HeroSection = styled.section`
  background:
    radial-gradient(circle at 50% 50%, rgba(0, 155, 217, 0.45) 0%, transparent 65%),
    linear-gradient(135deg, #024995 0%, #009bd9 60%, #024995 100%);
  padding: 4rem 1rem 0rem;
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 45vh;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      linear-gradient(rgba(255, 255, 255, 0.15) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 0.15) 1px, transparent 1px);
    background-size: 200px 200px;
    pointer-events: none;
    z-index: 1;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 20%;
    right: 10%;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    pointer-events: none;
    z-index: 1;
    animation: float 6s ease-in-out infinite;
  }
  
  @keyframes slideInRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes float {
    0%, 100% {
      transform: translateY(0px) rotate(0deg);
    }
    50% {
      transform: translateY(-20px) rotate(2deg);
    }
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateX(-30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  @media (max-width: 768px) {
    text-align: center;
    padding: 4rem 0rem 0rem;
  }
`;

export const HeroContent = styled.div`
  color: white;
  max-width: 1200px;
  width: 100%;
  display: flex;
  gap: 4rem;
  align-items: center;
  z-index: 2;
  position: relative;
  animation: scaleIn 1s ease-out;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const HeroTextColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
  padding-right: 2rem;
  
  @media (max-width: 1024px) {
    padding-right: 1rem;
  }
  
  @media (max-width: 768px) {
    text-align: center;
    padding-right: 0;
    order: 1;
  }
`;

export const HeroImageColumn = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 2rem;
  
  img {
    width: 100%;
    max-width: 450px;
    height: auto;
    animation: slideInRight 1s ease-out 0.5s both;
    filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.3));
    transition: all 0.3s ease;
    
    &:hover {
      transform: scale(1.05) rotate(2deg);
      filter: drop-shadow(0 15px 40px rgba(0, 0, 0, 0.4));
    }
  }
  
  @media (max-width: 1024px) {
    padding-left: 1rem;
    
    img {
      max-width: 380px;
    }
  }
  
  @media (max-width: 768px) {
    justify-content: center;
    padding-left: 0;
    order: 2;
    margin-bottom: 0rem;
    
    img {
      max-width: 320px;
    }
  }
  
  @media (max-width: 480px) {
    img {
      max-width: 280px;
    }
  }
`;

export const HeroTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
  text-transform: uppercase;
  animation: fadeInLeft 1s ease-out 0.3s both;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    right: 0;
    width: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.85) 100%);
    animation: expandWidth 1.5s ease-out 1.5s both;
  }
  
  @keyframes expandWidth {
    from {
      width: 0;
    }
    to {
      width: 100px;
    }
  }
  
  @media (max-width: 1024px) {
    font-size: 2.5rem;
  }
  
  @media (max-width: 768px) {
    font-size: 2rem;
    text-align: center;
    
    &::after {
      left: 50%;
      right: auto;
      transform: translateX(-50%);
    }
  }
  
  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

export const Highlight = styled.span`
  color: var(--color-primary-c);
  position: relative;
  display: inline-block;
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: linear-gradient(90deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.85) 100%);
    animation: highlightExpand 1s ease-out 2s both;
  }
  
  @keyframes highlightExpand {
    from {
      width: 0;
    }
    to {
      width: 100%;
    }
  }
`;

export const HeroSubtitle = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.9;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 1px;
  animation: fadeInLeft 1s ease-out 0.6s both;
`;

export const HeroButtons = styled.div`
  display: flex;
  gap: 1rem;
  animation: fadeInUp 1s ease-out 0.9s both;
  justify-content: flex-end;
  
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const PrimaryButton = styled.button`
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
  color: #2d3748;
  border: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    background: linear-gradient(135deg, rgba(var(--color-primary-c-rgb), 0.95) 0%, var(--color-primary-c) 100%);
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 8px 25px rgba(var(--color-primary-c-rgb), 0.4);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(0) scale(1.02);
  }
`;

export const SecondaryButton = styled.a`
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1.1rem;
  text-decoration: none;
  display: inline-block;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background: rgba(255, 255, 255, 0.1);
    transition: width 0.3s ease;
  }
  
  &:hover {
    background: white;
    color: var(--color-primary-b);
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 8px 20px rgba(255, 255, 255, 0.2);
    
    &::before {
      width: 100%;
    }
  }
  
  &:active {
    transform: translateY(-1px) scale(1.02);
  }
`;



export const Section = styled.section`
  padding: 5rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  background: white;
`;

export const TrajetoriaSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 193, 7, 0.08) 0%, transparent 50%),
                radial-gradient(circle at 20% 80%, rgba(30, 136, 229, 0.08) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const TrajetoriaContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const TrajetoriaTopSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 4rem;
  align-items: center;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 3rem;
    margin-bottom: 1.5rem;
  }
`;

export const TrajetoriaBottomSection = styled.div`
  margin-top: 1rem;
`;

export const TrajetoriaBottomText = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

export const TrajetoriaImage = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px;
`;

export const ImageContainer = styled.div`
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-c) 100%);
  width: 220px;
  height: 320px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  bottom: 50px;
  right: 80px;
  position: relative;
  box-shadow: 0 15px 35px rgba(var(--color-primary-a-rgb), 0.45), 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 1;

  &:hover {
    transform: translateY(-5px) rotate(2deg);
    box-shadow: 0 20px 40px rgba(var(--color-primary-a-rgb), 0.55), 0 8px 20px rgb(0, 0, 0);
  }

  &::before {
    content: 'DESDE 2000';
    position: absolute;
    top: -15px;
    left: -15px;
    background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
    color: white;
    padding: 0.6rem 1.2rem;
    border-radius: 8px;
    font-size: 0.8rem;
    font-weight: 700;
    transform: rotate(-12deg);
    box-shadow: 0 4px 15px rgba(var(--color-primary-a-rgb), 0.5);
    letter-spacing: 0.5px;
    z-index: 3;
  }
`;

export const ProfileImage = styled.div`
  background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
  width: 220px;
  height: 320px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  position: absolute;
  bottom: -10px;
  right: 10px;
  box-shadow: 0 15px 35px rgba(var(--color-primary-a-rgb), 0.45), 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;
  z-index: 2;

  &:hover {
    transform: translateY(-5px) rotate(-2deg);
    box-shadow: 0 20px 40px rgba(var(--color-primary-a-rgb), 0.55), 0 8px 20px rgb(0, 0, 0);
  }
`;

export const TrajetoriaText = styled.div`
  color: #2d3748;
`;

export const TrajetoriaTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: 800;
  margin-bottom: 2.5rem;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.2;
  letter-spacing: -0.5px;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
    text-align: center;
  }
`;

export const TrajetoriaDescription = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: #4a5568;
  text-align: justify;
  font-weight: 400;

  @media (max-width: 768px) {
    text-align: left;
  }
`;

export const ResultadosList = styled.div`
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-left: 4px solid var(--color-primary-a);
  padding: 1.5rem;
  margin: 1.5rem 0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

export const ResultadosTitle = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  color: var(--color-primary-a);
  font-weight: 600;
  margin-bottom: 1rem;
`;

export const ResultadosItem = styled.div`
  display: flex;
  align-items: center;
  margin: 0.8rem 0;
  font-size: 1rem;
  color: #4a5568;
  font-weight: 500;

  &::before {
    content: '✓';
    background: linear-gradient(135deg, var(--color-primary-c) 0%, var(--color-primary-a) 100%);
    color: white;
    font-weight: bold;
    margin-right: 1rem;
    font-size: 0.8rem;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(var(--color-primary-c-rgb), 0.35);
  }
`;

export const ConquistaDestaque = styled.div`
  background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
  color: white;
  padding: 2rem;
  margin: 2rem 0;
  border-radius: 15px;
  text-align: center;
  box-shadow: 0 8px 25px rgba(var(--color-primary-a-rgb), 0.3);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 30% 70%, rgba(var(--color-primary-c-rgb), 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  p {
    font-size: 1.2rem;
    line-height: 1.6;
    font-weight: 600;
    margin: 0;
    position: relative;
    z-index: 1;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 3rem;
  color: #2d3748;
`;

export const AboutContent = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 4rem;
  align-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const AboutText = styled.div`
  h3 {
    font-size: 1.8rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #2d3748;
  }
  
  p {
    font-size: 1.1rem;
    line-height: 1.7;
    color: #4a5568;
    margin-bottom: 1.5rem;
  }
`;

export const AboutStats = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Stat = styled.div`
  text-align: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  border-radius: 12px;
  color: white;
`;

export const StatNumber = styled.div`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
`;

export const StatLabel = styled.div`
  font-size: 0.9rem;
  opacity: 0.9;
`;

export const ComoFuncionaSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 80%, rgba(var(--color-primary-a-rgb), 0.05) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(var(--color-primary-c-rgb), 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const ComoFuncionaContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
`;

export const ComoFuncionaTitle = styled.h2`
  font-size: 3rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1rem;
  text-align: center;
  letter-spacing: -0.5px;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const ComoFuncionaHeaderGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 2rem;
  margin-bottom: 5rem;
  align-items: center;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    text-align: center;
  }
`;

export const ComoFuncionaSubtitle = styled.div`
  font-size: 2.8rem;
  color: #1a202c;
  text-align: right;
  line-height: 1.1;
  font-weight: 300;
  white-space: nowrap;
  
  strong {
    font-weight: 800;
    background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.85) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  @media (max-width: 768px) {
    text-align: center;
    font-size: 2.2rem;
    white-space: normal;
  }
`;

export const ComoFuncionaDivider = styled.div`
  width: 3px;
  height: 80px;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-c) 100%);
  justify-self: center;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ComoFuncionaDescription = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.7;
  text-align: left;
  font-weight: 400;
  
  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const PassosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2.5rem;
  margin-bottom: 4rem;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const PassoCard = styled.div`
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  padding: 2.5rem 2rem;
  border-radius: 20px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--color-primary-a) 0%, var(--color-primary-c) 100%);
    transform: scaleX(0);
    transition: transform 0.4s ease;
  }
  
  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1);
    
    &::before {
      transform: scaleX(1);
    }
  }
`;

export const PassoIcon = styled.div`
  font-size: 4.5rem;
  margin-bottom: 2rem;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
  transition: all 0.3s ease;
  color: var(--color-primary-a);
  
  .PassoCard:hover & {
    transform: scale(1.1) rotate(5deg);
  }
`;

export const PassoTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
  color: #1a202c;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const PassoDescription = styled.p`
  color: #4a5568;
  line-height: 1.6;
  font-size: 1.05rem;
  font-weight: 500;
  opacity: 0.9;
  
  strong {
    color: var(--color-primary-a);
    font-weight: 700;
  }
`;

export const ProvaSection = styled.div`
  text-align: center;
  margin: 3rem 0 2rem;
`;

export const ProvaSocial = styled.div`
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  color: white;
  padding: 1rem 2.5rem;
  border-radius: 50px;
  font-weight: 800;
  font-size: 1.2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: inline-block;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover::before {
    left: 100%;
  }
  
  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.8rem 2rem;
  }
`;

export const QueroSerAprovadoButton = styled.button`
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
  color: #2d3748;
  border: none;
  padding: 1.2rem 3.5rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(var(--color-primary-c-rgb), 0.3);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    background: linear-gradient(135deg, rgba(var(--color-primary-c-rgb), 0.95) 0%, var(--color-primary-c) 100%);
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 15px 35px rgba(var(--color-primary-c-rgb), 0.4), 0 5px 15px rgba(0, 0, 0, 0.1);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(-1px) scale(1.02);
  }
`;

export const DepoimentosSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 80%, rgba(var(--color-primary-a-rgb), 0.05) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(var(--color-primary-c-rgb), 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const DepoimentosContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
`;

export const DepoimentosTitle = styled.h2`
  font-size: 3rem;
  font-weight: 900;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const DepoimentosSubtitle = styled.p`
  font-size: 1.2rem;
  color: #4a5568;
  margin-bottom: 4rem;
  font-weight: 500;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 3rem;
  }
`;

export const DepoimentosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const DepoimentoCard = styled.div`
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(var(--color-primary-a-rgb), 0.05) 0%, rgba(var(--color-primary-c-rgb), 0.05) 100%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }

  &:hover::before {
    opacity: 1;
  }
`;

export const DepoimentoImage = styled.img`
  width: 100%;
  height: 470px;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;

  ${DepoimentoCard}:hover & {
    transform: scale(1.02);
  }
`;

export const TestimonialsSection = styled.section`
  padding: 5rem 2rem;
  background:
    radial-gradient(circle at 50% 50%, rgba(0, 155, 217, 0.35) 0%, transparent 60%),
    linear-gradient(135deg, #024995 0%, #009bd9 60%, #024995 100%);
  text-align: center;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 30% 20%, rgba(255,255,255,0.08) 0%, transparent 50%),
          radial-gradient(circle at 70% 80%, rgba(var(--color-primary-c-rgb), 0.08) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const TestimonialsTitle = styled.h2`
  font-size: 2.2rem;
  font-weight: 800;
  color: white;
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 1;

  span {
    background: linear-gradient(90deg, var(--color-primary-c), rgba(var(--color-primary-c-rgb), 0.7));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }
`;

export const TestimonialsSubtitle = styled.p`
  font-size: 1.05rem;
  color: rgba(255,255,255,0.75);
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
`;

export const CarouselContainer = styled.div`
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  z-index: 1;
`;

export const CarouselViewport = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding: 1rem 0;

  @media (max-width: 768px) {
    gap: 0;
  }
`;

interface SlideProps {
  isActive?: boolean;
  position?: string;
}

export const CarouselSlide = styled.div<SlideProps>`
  flex-shrink: 0;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  ${({ isActive }) => isActive ? `
    width: 380px;
    height: 480px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.35);
    transform: scale(1);
    z-index: 2;
    opacity: 1;
  ` : `
    width: 260px;
    height: 480px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.2);
    transform: scale(0.88);
    z-index: 1;
    opacity: 0.5;
    filter: blur(1.5px);
  `}

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    ${({ isActive }) => isActive ? `
      width: 85vw;
      height: auto;
    ` : `
      display: none;
    `}

    img {
      height: auto;
      object-fit: contain;
    }
  }
`;

export const CarouselControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 2rem;
`;

export const CarouselButton = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.3);
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(10px);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255,255,255,0.25);
    border-color: rgba(255,255,255,0.5);
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`;

export const CarouselDots = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const CarouselDot = styled.button<{ active: boolean }>`
  width: ${({ active }) => active ? '24px' : '8px'};
  height: 8px;
  border-radius: 4px;
  border: none;
  background: ${({ active }) => active ? 'var(--color-primary-c)' : 'rgba(255,255,255,0.35)'};
  cursor: pointer;
  transition: all 0.4s ease;

  &:hover {
    background: ${({ active }) => active ? 'rgba(var(--color-primary-c-rgb), 0.75)' : 'rgba(255,255,255,0.55)'};
  }
`;

export const CarouselCounter = styled.span`
  color: rgba(255,255,255,0.6);
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 1px;
  min-width: 50px;
`;

export const RegulamentosSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 70% 30%, rgba(var(--color-primary-a-rgb), 0.04) 0%, transparent 50%),
          radial-gradient(circle at 30% 70%, rgba(var(--color-primary-c-rgb), 0.04) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const RegulamentosContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
`;

export const RegulamentosTitle = styled.h2`
  font-size: 3.2rem;
  font-weight: 900;
  color: white;
  margin: 5rem 0 0rem 0;
  text-transform: uppercase;
  line-height: 1.2;
  letter-spacing: -0.5px;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
    margin: 2rem 0 1.5rem 0;
  }
`;

export const RegulamentosList = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 4rem;
  
  li {
    color: #4a5568;
    margin-bottom: 1rem;
    font-size: 0.9rem;
    line-height: 1.6;
    text-align: left;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const RegulamentosDocuments = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 4rem;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }
`;

export const DocumentLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  color: var(--color-primary-b);
  text-decoration: none;
  padding: 1.2rem 2.5rem;
  border-radius: 50px;
  font-weight: 800;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(var(--color-primary-a-rgb), 0.2);
  border: none;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(var(--color-primary-a-rgb), 0.1), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    background: #f8f9fa;
    transform: translateY(-4px) scale(1.05);
    box-shadow: 0 15px 40px rgba(var(--color-primary-a-rgb), 0.3), 0 8px 20px rgba(0, 0, 0, 0.1);
    text-decoration: none;
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 8px 25px rgba(var(--color-primary-a-rgb), 0.2);
  }
  
  svg {
    width: 18px;
    height: 18px;
    fill: currentColor;
  }
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 1rem 2rem;
  }
`;

export const TodosOsPlanosTitle = styled.h3`
  font-size: 2.2rem;
  font-weight: 800;
  background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 4rem;
  letter-spacing: -0.3px;
  text-transform: uppercase;
`;

export const RecursosIncluidos = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
`;

export const RecursoIncluido = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.5rem 1rem;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-8px);
  }
`;

export const RecursoIcon = styled.div`
  background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
  color: white;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 8px 25px rgba(var(--color-primary-a-rgb), 0.3);
  transition: all 0.3s ease;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-c) 100%);
    border-radius: 50%;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  .RecursoIncluido:hover & {
    transform: scale(1.1) rotate(-5deg);
    box-shadow: 0 12px 35px rgba(var(--color-primary-a-rgb), 0.4);
    
    &::before {
      opacity: 1;
    }
  }
`;

export const RecursoTitulo = styled.h4`
  font-size: 0.85rem;
  font-weight: 800;
  color: #2d3748;
  text-transform: uppercase;
  line-height: 1.3;
  letter-spacing: 0.5px;
  margin: 0;
  text-align: center;
  max-width: 120px;
`;

export const PlanosSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 30% 70%, rgba(var(--color-primary-a-rgb), 0.06) 0%, transparent 50%),
          radial-gradient(circle at 70% 30%, rgba(var(--color-primary-c-rgb), 0.06) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const PlanosContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
`;

export const PlanosHeader = styled.div`
  margin-bottom: 4rem;
`;

export const PlanosTitle = styled.h2`
  font-size: 3rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  letter-spacing: -0.5px;
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const PlanosSubtitle = styled.p`
  font-size: 1.2rem;
  color: #4a5568;
  line-height: 1.7;
  max-width: 700px;
  margin: 0 auto;
  font-weight: 400;
`;

export const PlanosCorrecaoButton = styled.button`
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
  color: #2d3748;
  border: none;
  padding: 1.2rem 2rem;
  border-radius: 15px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 2rem auto;
  display: block;
  box-shadow: 0 4px 15px rgba(var(--color-primary-c-rgb), 0.3);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    background: linear-gradient(135deg, rgba(var(--color-primary-c-rgb), 0.95) 0%, var(--color-primary-c) 100%);
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 8px 25px rgba(var(--color-primary-c-rgb), 0.4);
    
    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-1px) scale(1.02);
  }

  @media (max-width: 768px) {
    padding: 1rem 1.5rem;
    font-size: 0.9rem;
    margin: 1.5rem auto;
  }
`;

export const PlanosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const PlanoCard = styled.div<{ destaque?: boolean }>`
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08), 0 3px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.8);
  overflow: hidden;
  min-height: 450px;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, var(--color-primary-a) 0%, var(--color-primary-c) 100%);
    transform: scaleX(0);
    transition: transform 0.4s ease;
  }
  
  ${props => props.destaque && `
    background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
    color: white;
    transform: scale(1.05);
    box-shadow: 0 15px 40px rgba(var(--color-primary-a-rgb), 0.3), 0 8px 20px rgba(0, 0, 0, 0.1);
    
    &::before {
      background: linear-gradient(90deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
      transform: scaleX(1);
    }
    
    &::after {
      content: 'MAIS POPULAR';
      position: absolute;
      top: 40px;
      right: -40px;
      background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
      color: #2d3748;
      padding: 8px 40px;
      font-size: 0.8rem;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 1px;
      transform: rotate(45deg);
      box-shadow: 0 4px 15px rgba(var(--color-primary-c-rgb), 0.4);
      z-index: 10;
      border-radius: 4px;
    }
    
    h3, p, div {
      color: white;
    }
    
    ${PlanoTipo} {
      color: white !important;
      background: none !important;
      -webkit-text-fill-color: white !important;
    }
    
    ${PlanoPreco} {
      background: rgba(255, 255, 255, 0.15);
      border: 2px solid rgba(255, 255, 255, 0.3);
      
      ${PrecoValor} {
        color: rgb(255, 255, 255) !important;
        font-size: 2.2rem;
        background: none !important;
        -webkit-text-fill-color: white !important;
      }
      
      ${PrecoTotal} {
        color: rgb(255, 255, 255);
      }
    }
    
    button {
      background: white !important;
      color: var(--color-primary-b) !important;
      
      &:hover {
        background: #f8f9fa !important;
        color: var(--color-primary-a) !important;
        transform: translateY(-2px) scale(1.05) !important;
      }
    }
  `}
  
  &:hover {
    transform: translateY(-8px) ${props => props.destaque ? 'scale(1.05)' : 'scale(1.02)'};
    box-shadow: ${props => props.destaque ? '0 20px 50px rgba(var(--color-primary-a-rgb), 0.4), 0 10px 25px rgba(0, 0, 0, 0.15)' : '0 15px 35px rgba(0, 0, 0, 0.12), 0 8px 20px rgba(0, 0, 0, 0.08)'};
    
    &::before {
      transform: scaleX(1);
    }
  }
`;

export const PlanoHeader = styled.div`
  margin-bottom: 2rem;
`;

export const PlanoTipo = styled.h3`
  font-size: 1.8rem;
  font-weight: 800;
  background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: -0.3px;
  line-height: 1.2;
`;

export const PlanoDescricao = styled.p`
  font-size: 0.9rem;
  color: #4a5568;
  text-transform: uppercase;
  font-weight: 600;
`;

export const PlanoPreco = styled.div`
  text-align: center;
  margin: 1.5rem 0;
  padding: 2rem 1.5rem;
  background: linear-gradient(145deg, #f8f9fa 0%, #edf2f7 100%);
  border-radius: 16px;
  border: 2px solid rgba(233, 236, 239, 0.6);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(var(--color-primary-a-rgb), 0.03) 0%, rgba(var(--color-primary-c-rgb), 0.03) 100%);
    pointer-events: none;
  }
`;

export const PrecoValor = styled.div`
  font-size: 2.2rem;
  font-weight: 900;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  position: relative;
  z-index: 1;
  letter-spacing: -0.5px;
`;

export const PrecoTotal = styled.div`
  font-size: 1rem;
  color: #6c757d;
  font-weight: 600;
  position: relative;
  z-index: 1;
  opacity: 0.8;
`;

export const PlanoFeatures = styled.div`
  margin-bottom: 2rem;
  text-align: left;
`;

export const Feature = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #4a5568;
  margin-bottom: 1rem;
  padding: 0.25rem 0;
  font-weight: 500;
  line-height: 1.5;
  transition: all 0.3s ease;
  
  &::before {
    content: '✓';
    background: linear-gradient(135deg, var(--color-primary-c) 0%, var(--color-primary-a) 100%);
    color: white;
    font-weight: bold;
    margin-right: 1rem;
    font-size: 0.8rem;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(var(--color-primary-c-rgb), 0.35);
  }
  
  &:hover {
    color: #2d3748;
    transform: translateX(4px);
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const FeatureSpacer = styled.div`
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: transparent;
  margin-bottom: 1rem;
  padding: 0.25rem 0;
  font-weight: 500;
  line-height: 1.5;
  height: 1.5rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const VerMaisButton = styled.button`
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 0rem;
  align-self: center;
  
  &:hover {
    background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(var(--color-primary-a-rgb), 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

export const CorrecaoButton = styled.button`
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%) !important;
  color: #2d3748 !important;
  border: none;
  padding: 1.2rem 2rem;
  border-radius: 15px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(var(--color-primary-c-rgb), 0.3);
  margin-top: 1rem;
  width: 100%;

  /* Especificidade extra para sobrescrever estilos do card VIP */
  &&& {
    background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%) !important;
    color: #2d3748 !important;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    background: linear-gradient(135deg, rgba(var(--color-primary-c-rgb), 0.95) 0%, var(--color-primary-c) 100%) !important;
    color: #2d3748 !important;
    transform: translateY(-3px) scale(1.05) !important;
    box-shadow: 0 15px 35px rgba(var(--color-primary-c-rgb), 0.4), 0 5px 15px rgba(0, 0, 0, 0.1);

    /* Especificidade extra para hover */
    &&& {
      background: linear-gradient(135deg, rgba(var(--color-primary-c-rgb), 0.95) 0%, var(--color-primary-c) 100%) !important;
      color: #2d3748 !important;
    }

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-1px) scale(1.02) !important;
  }

  @media (max-width: 768px) {
    padding: 1rem 1.5rem;
    font-size: 0.9rem;
  }
`;

export const PlanoButton = styled.button`
  background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
  color: white;
  border: none;
  padding: 1.2rem 2rem;
  border-radius: 15px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  width: 100%;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(var(--color-primary-a-rgb), 0.3);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 8px 25px rgba(var(--color-primary-a-rgb), 0.4), 0 4px 12px rgba(0, 0, 0, 0.1);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(-1px) scale(1.01);
    box-shadow: 0 4px 15px rgba(var(--color-primary-a-rgb), 0.3);
  }
`;

export const EbookSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 80%, rgba(var(--color-primary-a-rgb), 0.05) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(var(--color-primary-c-rgb), 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const EbookContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 3rem;
    text-align: center;
  }
`;

export const EbookImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  img {
    width: 100%;
    max-width: 400px;
    height: auto;
    border-radius: 20px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-10px) scale(1.02);
      box-shadow: 0 30px 60px rgba(0, 0, 0, 0.2);
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: -20px;
    left: -20px;
    right: -20px;
    bottom: -20px;
    background: linear-gradient(135deg, rgba(var(--color-primary-a-rgb), 0.1) 0%, rgba(var(--color-primary-c-rgb), 0.1) 100%);
    border-radius: 30px;
    z-index: -1;
    animation: ebookPulse 3s ease-in-out infinite;
  }

  @keyframes ebookPulse {
    0%, 100% {
      transform: scale(1);
      opacity: 0.7;
    }
    50% {
      transform: scale(1.05);
      opacity: 0.3;
    }
  }
`;

export const EbookTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const EbookTitle = styled.h2`
  font-size: 3rem;
  font-weight: 900;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const EbookSubtitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 1rem;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const EbookDescription = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.7;
  margin-bottom: 1.5rem;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const EbookHighlight = styled.div`
  background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 15px;
  font-weight: 600;
  font-size: 1.1rem;
  text-align: center;
  
  margin-bottom: 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
  }

  &:hover::before {
    left: 100%;
  }
`;

export const EbookButton = styled.button`
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
  color: #2d3748;
  border: none;
  padding: 1.5rem 3rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(var(--color-primary-a-rgb), 0.3);
  

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }

  &:hover {
    background: linear-gradient(135deg, rgba(var(--color-primary-c-rgb), 0.95) 0%, var(--color-primary-c) 100%);
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 15px 35px rgba(var(--color-primary-c-rgb), 0.4), 0 5px 15px rgba(0, 0, 0, 0.1);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-1px) scale(1.02);
  }

  @media (max-width: 768px) {
    align-self: center;
    width: 100%;
    max-width: 300px;
  }
`;

export const ZoomCtaSection = styled.section`
  padding: 5.5rem 2rem;
  background: radial-gradient(circle at 50% 50%, rgba(0, 155, 217, 0.4) 0%, transparent 60%),
              radial-gradient(circle at 10% 20%, rgba(var(--color-primary-c-rgb), 0.15) 0%, transparent 45%),
              linear-gradient(135deg, #024995 0%, #009bd9 60%, #024995 100%);
  color: #f8fafc;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(rgba(255, 255, 255, 0.18) 1px, transparent 1px);
    background-size: 140px 140px;
    opacity: 0.25;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    right: -120px;
    bottom: -120px;
    width: 280px;
    height: 280px;
    background: radial-gradient(circle, rgba(var(--color-primary-c-rgb), 0.35) 0%, transparent 65%);
    filter: blur(10px);
    pointer-events: none;
  }
`;

export const ZoomCtaContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 2.5rem;
  align-items: center;
  position: relative;
  z-index: 1;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

export const ZoomCtaTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;

  @media (max-width: 900px) {
    align-items: center;
  }
`;

export const ZoomCtaBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.45rem 1rem;
  border-radius: 999px;
  background: var(--color-primary-c);
  color: var(--color-primary-b);
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: 'Space Grotesk', sans-serif;
`;

export const ZoomCtaTitle = styled.h2`
  font-size: clamp(2.2rem, 4vw, 3.4rem);
  line-height: 1.1;
  font-weight: 700;
  margin: 0;
  font-family: 'Fraunces', serif;
  color: #f8fafc;
`;

export const ZoomCtaDescription = styled.p`
  font-size: 1.05rem;
  line-height: 1.7;
  color: #e2e8f0;
  margin: 0;
  max-width: 560px;

  @media (max-width: 900px) {
    max-width: 100%;
  }
`;

export const ZoomCtaActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;

  @media (max-width: 900px) {
    justify-content: center;
  }
`;

export const ZoomCtaPrimaryButton = styled.button`
  border: none;
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
  color: var(--color-primary-b);
  padding: 1rem 2.4rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 1.05rem;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(var(--color-primary-c-rgb), 0.35);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
  max-width: 100%;
  text-align: center;

  &:hover {
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 16px 32px rgba(var(--color-primary-c-rgb), 0.45);
  }
`;

export const ZoomCtaSecondaryButton = styled.a`
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(15, 23, 42, 0.25);
  color: #f8fafc;
  padding: 0.9rem 1.7rem;
  border-radius: 999px;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  transition: transform 0.3s ease, border-color 0.3s ease, background 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(255, 255, 255, 0.7);
    background: rgba(15, 23, 42, 0.4);
  }
`;

export const ZoomCtaInfoCard = styled.div`
  background: rgba(15, 23, 42, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 2rem;
  backdrop-filter: blur(10px);
  box-shadow: 0 24px 45px rgba(5, 20, 55, 0.35);
  text-align: left;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.08), transparent 60%);
    opacity: 0.6;
  }

  @media (max-width: 900px) {
    text-align: center;
  }
`;

export const ZoomCtaInfoTitle = styled.h3`
  font-size: 1.1rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin: 0 0 1rem;
  font-family: 'Space Grotesk', sans-serif;
  position: relative;
  z-index: 1;
`;

export const ZoomCtaInfoList = styled.ul`
  list-style: none;
  margin: 0 0 1.5rem;
  padding: 0;
  display: grid;
  gap: 0.8rem;
  position: relative;
  z-index: 1;

  li {
    position: relative;
    padding-left: 1.6rem;
    line-height: 1.5;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0.55rem;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: var(--color-primary-c);
      box-shadow: 0 0 0 4px rgba(var(--color-primary-c-rgb), 0.2);
    }
  }

  @media (max-width: 900px) {
    li {
      padding-left: 0;

      &::before {
        display: none;
      }
    }
  }
`;

export const ZoomCtaInfoButton = styled.button`
  border: none;
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
  color: var(--color-primary-b);
  padding: 0.85rem 1.6rem;
  border-radius: 999px;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 12px 28px rgba(var(--color-primary-c-rgb), 0.35);
  position: relative;
  z-index: 1;
  margin-bottom: 1.4rem;

  &:hover {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 16px 32px rgba(var(--color-primary-c-rgb), 0.45);
  }

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const ZoomCtaInfoFooter = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.2rem;
  border-radius: 999px;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  border: 1px solid rgba(255, 255, 255, 0.35);
  color: #f1f8f4;
  font-weight: 700;
  font-size: 0.98rem;
  box-shadow: 0 12px 24px rgba(var(--color-primary-a-rgb), 0.35);
  position: relative;
  z-index: 1;
  cursor: pointer;
  appearance: none;

  @media (max-width: 900px) {
    justify-content: center;
  }
`;

// Seção de Confiança
export const ConfiancaSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 30% 70%, rgba(var(--color-primary-a-rgb), 0.05) 0%, transparent 50%),
          radial-gradient(circle at 70% 30%, rgba(var(--color-primary-c-rgb), 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const ConfiancaContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  z-index: 1;
`;

export const ConfiancaTitle = styled.h2`
  font-size: 3rem;
  font-weight: 900;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 4rem;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2.2rem;
    margin-bottom: 3rem;
  }
`;

export const GarantiaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 4rem;
`;

export const GarantiaTexto = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  background: white;
  padding: 3rem 4rem;
  border-radius: 20px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
  border: 2px solid rgba(var(--color-primary-a-rgb), 0.1);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(var(--color-primary-a-rgb), 0.05), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
    border-color: rgba(var(--color-primary-a-rgb), 0.2);
    
    &::before {
      left: 100%;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 2.5rem 2rem;
    gap: 1.5rem;
  }
`;

export const GarantiaIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  border-radius: 50%;
  color: white;
  flex-shrink: 0;
  box-shadow: 0 8px 25px rgba(var(--color-primary-a-rgb), 0.3);
  
  svg {
    width: 48px;
    height: 48px;
  }

  @media (max-width: 768px) {
    width: 70px;
    height: 70px;
    
    svg {
      width: 40px;
      height: 40px;
    }
  }
`;

export const GarantiaTextoContent = styled.div`
  text-align: left;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const GarantiaTitulo = styled.h3`
  font-size: 2rem;
  font-weight: 800;
  color: #2d3748;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: -0.5px;

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }
`;

export const GarantiaDescricao = styled.p`
  font-size: 1.3rem;
  color: #4a5568;
  font-weight: 600;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const SelosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const SeloItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(var(--color-primary-a-rgb), 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(var(--color-primary-c-rgb), 0.05), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
    border-color: rgba(var(--color-primary-c-rgb), 0.2);
    
    &::before {
      left: 100%;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    text-align: center;
    padding: 1.5rem;
  }
`;

export const SeloIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
  border-radius: 50%;
  color: white;
  flex-shrink: 0;
  box-shadow: 0 6px 20px rgba(var(--color-primary-c-rgb), 0.3);
  
  svg {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    
    svg {
      width: 28px;
      height: 28px;
    }
  }
`;

export const SeloTexto = styled.span`
  font-size: 1.1rem;
  font-weight: 700;
  color: #2d3748;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

// Seção FAQ
export const FAQSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 80%, rgba(var(--color-primary-a-rgb), 0.03) 0%, transparent 50%),
          radial-gradient(circle at 80% 20%, rgba(var(--color-primary-c-rgb), 0.03) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const FAQContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const FAQTitle = styled.h2`
  font-size: 3rem;
  font-weight: 900;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-align: center;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const FAQSubtitle = styled.p`
  font-size: 1.3rem;
  color: #4a5568;
  text-align: center;
  margin-bottom: 4rem;
  font-weight: 500;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 3rem;
  }
`;

export const FAQContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FAQItem = styled.div`
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(var(--color-primary-a-rgb), 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
    border-color: rgba(var(--color-primary-a-rgb), 0.2);
  }
`;

export const FAQQuestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  cursor: pointer;
  background: white;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(var(--color-primary-a-rgb), 0.05), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    background: rgba(var(--color-primary-a-rgb), 0.02);
    
    &::before {
      left: 100%;
    }
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

export const FAQQuestionText = styled.h3`
  font-size: 1.3rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
  flex: 1;
  padding-right: 1rem;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

interface FAQIconProps {
  isOpen?: boolean;
}

export const FAQIcon = styled.div<FAQIconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  border-radius: 50%;
  color: white;
  flex-shrink: 0;
  transition: all 0.3s ease;
  
  svg {
    width: 24px;
    height: 24px;
    transition: transform 0.3s ease;
    transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  }
  
  ${FAQItem}:hover & {
    background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 35px;
    height: 35px;
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const FAQAnswer = styled.div`
  padding: 0 2rem 2rem;
  border-top: 1px solid rgba(var(--color-primary-a-rgb), 0.1);
  background: rgba(var(--color-primary-a-rgb), 0.02);
  animation: slideDown 0.3s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
      padding-top: 0;
      padding-bottom: 0;
    }
    to {
      opacity: 1;
      max-height: 200px;
      padding-top: 0;
      padding-bottom: 2rem;
    }
  }

  @media (max-width: 768px) {
    padding: 0 1.5rem 1.5rem;
    
    @keyframes slideDown {
      to {
        padding-bottom: 1.5rem;
      }
    }
  }
`;

export const FAQAnswerText = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  line-height: 1.7;
  margin: 1.5rem 0 0;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-top: 1rem;
  }
`;

export const CallToActionSection = styled.section`
  background:
    radial-gradient(circle at 50% 50%, rgba(0, 155, 217, 0.38) 0%, transparent 60%),
    linear-gradient(135deg, #024995 0%, #009bd9 60%, #024995 100%);
  padding: 6rem 2rem;
  text-align: center;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 30% 70%, rgba(var(--color-primary-c-rgb), 0.1) 0%, transparent 50%),
                radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const CallToActionContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const CallToActionTitle = styled.h2`
  font-size: 3.2rem;
  font-weight: 900;
  color: white;
  margin-bottom: 3rem;
  text-transform: uppercase;
  line-height: 1.2;
  letter-spacing: -0.5px;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const CallToActionButton = styled.button`
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
  color: #2d3748;
  border: none;
  padding: 1.8rem 5rem;
  border-radius: 50px;
  font-weight: 800;
  font-size: 1.3rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(var(--color-primary-a-rgb), 0.3);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    background: linear-gradient(135deg, rgba(var(--color-primary-c-rgb), 0.95) 0%, var(--color-primary-c) 100%);
    transform: translateY(-4px) scale(1.05);
    box-shadow: 0 15px 40px rgba(var(--color-primary-c-rgb), 0.4), 0 8px 20px rgba(0, 0, 0, 0.1);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 8px 25px rgba(var(--color-primary-c-rgb), 0.3);
  }
`;

export const Footer = styled.footer`
  background:
    radial-gradient(circle at 30% 50%, rgba(0, 155, 217, 0.28) 0%, transparent 55%),
    linear-gradient(135deg, #024995 0%, #009bd9 60%, #024995 100%);
  color: white;
  padding: 4rem 2rem 1rem;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 80%, rgba(var(--color-primary-a-rgb), 0.08) 0%, transparent 50%),
                radial-gradient(circle at 80% 20%, rgba(var(--color-primary-c-rgb), 0.05) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 3rem;
  position: relative;
  z-index: 1;
`;

export const FooterSection = styled.div`
  h4 {
    font-size: 1.3rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  p, a {
    color: #cbd5e0;
    text-decoration: none;
    line-height: 1.7;
    display: block;
    margin-bottom: 0.8rem;
    font-weight: 400;
    transition: all 0.3s ease;
    
    &:hover {
      color: var(--color-primary-c);
      transform: translateX(4px);
    }
  }
`;

export const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  
  img {
    height: 58px;
    width: auto;
    object-fit: contain;
    opacity: 0.92;
    transition: opacity 0.2s ease;
    
    &:hover {
      opacity: 1;
    }
  }
`;

export const FooterBottom = styled.div`
  max-width: 1200px;
  margin: 3rem auto 0;
  padding-top: 2.5rem;
  border-top: 1px solid rgba(var(--color-primary-c-rgb), 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #cbd5e0;
  position: relative;
  z-index: 1;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const NewsletterForm = styled.div`
  display: flex;
  margin-top: 1.5rem;
  border-radius: 50px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  
  input {
    flex: 1;
    padding: 1rem 1.5rem;
    border: none;
    background: rgba(255, 255, 255, 0.1);
    color: white;
    font-size: 1rem;
    outline: none;
    
    &::placeholder {
      color: rgba(255, 255, 255, 0.7);
    }
  }
  
  button {
    background: white;
    color: var(--color-primary-b);
    border: none;
    padding: 1rem 2rem;
    cursor: pointer;
    font-weight: 700;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
    
    &:hover {
      background: #f8f9fa;
      transform: scale(1.05);
    }
  }
`;

export const SocialLinks = styled.div`
  span {
    color: #cbd5e0;
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-c) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      transform: scale(1.05);
      letter-spacing: 3px;
    }
  }
`;

export const WhatsAppButton = styled.a`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
  height: 60px;
  background: #25d366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
  z-index: 1000;
  transition: all 0.3s ease;
  text-decoration: none;
  animation: pulse 2s infinite;

  &:hover {
    background: #128c7e;
    transform: translateY(-3px) scale(1.1);
    box-shadow: 0 15px 35px rgba(37, 211, 102, 0.6);
  }

  &:active {
    transform: translateY(-1px) scale(1.05);
  }

  svg {
    width: 32px;
    height: 32px;
    color: white;
    transition: all 0.3s ease;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4), 0 0 0 0 rgba(37, 211, 102, 0.7);
    }
    70% {
      box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4), 0 0 0 10px rgba(37, 211, 102, 0);
    }
    100% {
      box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4), 0 0 0 0 rgba(37, 211, 102, 0);
    }
  }

  @media (max-width: 768px) {
    width: 55px;
    height: 55px;
    bottom: 20px;
    right: 20px;

    svg {
      width: 28px;
      height: 28px;
    }
  }
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 0rem;
  
  @media (max-width: 768px) {
    gap: 1rem;
    margin-top: 0.8rem;
  }
`;

export const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: #cbd5e0;
  text-decoration: none;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  svg {
    width: 24px;
    height: 24px;
    transition: all 0.3s ease;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    color: var(--color-primary-c);
    transform: translateY(-3px) scale(1.1);
    box-shadow: 0 8px 25px rgba(var(--color-primary-c-rgb), 0.3);
    
    svg {
      transform: scale(1.1);
    }
  }
  
  &:active {
    transform: translateY(-1px) scale(1.05);
  }
  
  @media (max-width: 768px) {
    width: 45px;
    height: 45px;
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

// Seção de Cursos (Presencial e Online)
export const CursosSection = styled.section`
  padding: 6rem 2rem;
  background: linear-gradient(135deg, var(--color-primary-b) 0%, var(--color-primary-a) 100%);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 20%, rgba(var(--color-primary-c-rgb), 0.15) 0%, transparent 40%),
      radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 40%);
    pointer-events: none;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
    background-size: 50px 50px;
    pointer-events: none;
  }
`;

export const CursosContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const CursosHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

export const CursosTitle = styled.h2`
  font-size: 3rem;
  font-weight: 900;
  color: white;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: -0.5px;
  text-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  
  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

export const CursosSubtitle = styled.p`
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.9);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const CursosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2.5rem;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const CursoCard = styled.div<{ tipo?: 'presencial' | 'online' }>`
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 24px;
  padding: 2.5rem;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    background: ${props => props.tipo === 'presencial' 
      ? 'linear-gradient(90deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%)' 
      : 'linear-gradient(90deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%)'};
  }
  
  &:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.3);
  }
  
  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

export const CursoCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const CursoIcon = styled.div<{ tipo?: 'presencial' | 'online' }>`
  width: 70px;
  height: 70px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.tipo === 'presencial' 
    ? 'linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%)' 
    : 'linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%)'};
  box-shadow: ${props => props.tipo === 'presencial' 
    ? '0 8px 25px rgba(var(--color-primary-c-rgb), 0.4)' 
    : '0 8px 25px rgba(var(--color-primary-a-rgb), 0.4)'};
  
  svg {
    width: 36px;
    height: 36px;
    color: white;
  }
`;

export const CursoTitulo = styled.h3`
  font-size: 1.8rem;
  font-weight: 800;
  background: linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const CursoFeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
`;

export const CursoFeature = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  padding: 0.7rem 0;
  font-size: 0.95rem;
  color: #4a5568;
  line-height: 1.5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  
  &:last-child {
    border-bottom: none;
  }
  
  &::before {
    content: '✓';
    background: linear-gradient(135deg, var(--color-primary-c) 0%, var(--color-primary-a) 100%);
    color: white;
    font-weight: bold;
    font-size: 0.7rem;
    min-width: 18px;
    height: 18px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2px;
    box-shadow: 0 2px 8px rgba(var(--color-primary-c-rgb), 0.35);
  }
`;

export const CursoResultado = styled.div`
  background: linear-gradient(135deg, rgba(var(--color-primary-a-rgb), 0.12) 0%, rgba(var(--color-primary-a-rgb), 0.04) 100%);
  border-left: 4px solid var(--color-primary-a);
  padding: 1.2rem 1.5rem;
  border-radius: 0 12px 12px 0;
  margin-bottom: 2rem;
  
  p {
    font-size: 0.95rem;
    color: var(--color-primary-b);
    font-weight: 600;
    margin: 0;
    line-height: 1.5;
    
    strong {
      color: var(--color-primary-b);
    }
  }
`;

export const CursoWhatsAppButton = styled.a<{ tipo?: 'presencial' | 'online' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  width: 100%;
  padding: 1.2rem 2rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1rem;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  background: ${props => props.tipo === 'presencial' 
    ? 'linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%)' 
    : 'linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%)'};
  color: ${props => props.tipo === 'presencial' ? '#2d3748' : 'white'};
  box-shadow: ${props => props.tipo === 'presencial' 
    ? '0 8px 25px rgba(var(--color-primary-c-rgb), 0.4)' 
    : '0 8px 25px rgba(var(--color-primary-a-rgb), 0.4)'};
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
  }
  
  &:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: ${props => props.tipo === 'presencial' 
      ? '0 15px 40px rgba(var(--color-primary-c-rgb), 0.5)' 
      : '0 15px 40px rgba(var(--color-primary-a-rgb), 0.5)'};
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(-1px) scale(1.01);
  }
  
  svg {
    width: 24px;
    height: 24px;
  }
  
  @media (max-width: 768px) {
    padding: 1rem 1.5rem;
    font-size: 0.9rem;
  }
`;

export const HeroCoursesButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
  align-items: flex-end;
  
  @media (max-width: 768px) {
    align-items: center;
  }
`;

export const HeroCoursesButtonsRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: flex-end;
  
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const HeroUrgentBanner = styled.div`
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 1.1rem;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(220, 38, 38, 0.4);
  animation: urgentPulse 2s ease-in-out infinite;
  text-align: center;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    animation: urgentShine 3s ease-in-out infinite;
  }
  
  @keyframes urgentPulse {
    0%, 100% {
      transform: scale(1);
      box-shadow: 0 4px 15px rgba(220, 38, 38, 0.4);
    }
    50% {
      transform: scale(1.02);
      box-shadow: 0 6px 20px rgba(220, 38, 38, 0.6);
    }
  }
  
  @keyframes urgentShine {
    0% {
      left: -100%;
    }
    50%, 100% {
      left: 100%;
    }
  }
  
  @media (max-width: 768px) {
    font-size: 0.95rem;
    padding: 0.9rem 1.5rem;
    width: 100%;
  }
`;

export const HeroCourseButton = styled.button<{ tipo?: 'presencial' | 'online' }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.8rem 1.5rem;
  border-radius: 25px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border: 2px solid white;
  background: ${props => props.tipo === 'presencial' 
    ? 'rgba(var(--color-primary-c-rgb), 0.2)' 
    : 'rgba(var(--color-primary-a-rgb), 0.2)'};
  color: white;
  
  &:hover {
    background: ${props => props.tipo === 'presencial' 
      ? 'linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%)' 
      : 'linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%)'};
    color: ${props => props.tipo === 'presencial' ? '#2d3748' : 'white'};
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 8px 25px rgba(255, 255, 255, 0.2);
  }
  
  svg {
    width: 18px;
    height: 18px;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const VagasAbertasBanner = styled.div`
  background: linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%);
  padding: 1rem 2rem;
  border-radius: 50px;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  box-shadow: 0 8px 30px rgba(var(--color-primary-c-rgb), 0.5);
  animation: vagasPulse 2s ease-in-out infinite;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    animation: vagasShine 3s ease-in-out infinite;
  }
  
  @keyframes vagasPulse {
    0%, 100% {
      transform: scale(1);
      box-shadow: 0 8px 30px rgba(var(--color-primary-c-rgb), 0.5);
    }
    50% {
      transform: scale(1.03);
      box-shadow: 0 12px 40px rgba(var(--color-primary-c-rgb), 0.7);
    }
  }
  
  @keyframes vagasShine {
    0% {
      left: -100%;
    }
    50%, 100% {
      left: 100%;
    }
  }
  
  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const VagasIcon = styled.div`
  width: 50px;
  height: 50px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: vagasIconBounce 1s ease-in-out infinite;
  
  svg {
    width: 28px;
    height: 28px;
    color: var(--color-primary-c);
  }
  
  @keyframes vagasIconBounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  }
  
  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    
    svg {
      width: 22px;
      height: 22px;
    }
  }
`;

export const VagasTexto = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
  
  span:first-child {
    font-size: 1.8rem;
    font-weight: 900;
    color: #2d3748;
    text-transform: uppercase;
    letter-spacing: 2px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  span:last-child {
    font-size: 0.9rem;
    font-weight: 600;
    color: #5d4037;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  @media (max-width: 768px) {
    text-align: center;
    
    span:first-child {
      font-size: 1.4rem;
    }
    
    span:last-child {
      font-size: 0.8rem;
    }
  }
`;

export const CursoCardBadge = styled.div<{ tipo?: 'presencial' | 'online' }>`
  position: absolute;
  top: 20px;
  right: 20px;
  background: ${props => props.tipo === 'presencial' 
    ? 'linear-gradient(135deg, var(--color-primary-c) 0%, rgba(var(--color-primary-c-rgb), 0.9) 100%)' 
    : 'linear-gradient(135deg, var(--color-primary-a) 0%, var(--color-primary-b) 100%)'};
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px ${props => props.tipo === 'presencial' 
    ? 'rgba(var(--color-primary-c-rgb), 0.4)' 
    : 'rgba(var(--color-primary-a-rgb), 0.4)'};
  animation: badgePulse 2s ease-in-out infinite;
  z-index: 10;
  
  @keyframes badgePulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }
  
  @media (max-width: 768px) {
    top: 15px;
    right: 15px;
    font-size: 0.65rem;
    padding: 0.4rem 0.8rem;
  }
`;

export const BackToTopButton = styled.button<{ show: boolean }>`
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: ${props => props.show ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(20px)'};
  width: 50px;
  height: 50px;
  background: var(--color-primary-b);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(var(--color-primary-a-rgb), 0.3);
  transition: all 0.3s ease;
  z-index: 999;
  opacity: ${props => props.show ? '1' : '0'};
  visibility: ${props => props.show ? 'visible' : 'hidden'};
  
  &:hover {
    background: var(--color-primary-a);
    transform: translateX(-50%) translateY(-3px);
    box-shadow: 0 6px 16px rgba(var(--color-primary-a-rgb), 0.4);
  }
  
  &:active {
    transform: translateX(-50%) translateY(-1px);
  }
  
  svg {
    width: 24px;
    height: 24px;
  }
  
  @media (max-width: 768px) {
    bottom: 20px;
    width: 45px;
    height: 45px;
    
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;